<template>
    <select
        class="form-select form-control calc-form-control"
        @input="$emit('input', $event.target.value)"
    >
        <option
            v-for="(option, index) in dropdownOptions"
            :key="index"
            :value="option.value"   
        >
            {{ option.text }}
        </option>
    </select>    
</template>

<script>
export default {
    props: {
        value: [String, Number],
        dropdownOptions: Array
    }   
}
</script>